import { graphql } from '@/gql';
import type { GetMailingsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getMailings = async ({
  searchType,
  phoneNumber,
  address,
  mailingTypes,
  startDate,
  endDate,
  pagination,
}: GetMailingsQueryVariables) => {
  const response = await queryExecute({
    query: graphql(`
      query GetMailings(
        $searchType: String!
        $phoneNumber: String
        $address: DeliveryAddressInputType
        $mailingTypes: [String!]!
        $startDate: String
        $endDate: String
        $pagination: PaginationInputType
      ) {
        getMailings(
          searchType: $searchType
          phoneNumber: $phoneNumber
          address: $address
          mailingTypes: $mailingTypes
          startDate: $startDate
          endDate: $endDate
          pagination: $pagination
        ) {
          count
          rows {
            id
            phoneNumber
            firstName
            lastName
            email
            streetAddress
            streetAddress2
            city
            state
            zip
            type
            lobParametersOverride
            createdAt
            updatedAt
            sentAt
            sendResult
            userId
          }
        }
      }
    `),
    variables: {
      searchType,
      phoneNumber,
      address,
      mailingTypes,
      startDate,
      endDate,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.getMailings;
};
